<template>
  <div>
    <!-- 头部 -->
    <top></top>
    <div class="main">
      <navMenu :active="active"></navMenu>
      <div class="content" v-loading.lock="loading">
        <div class="content-top">
          <div class="go-back" @click="goBack">返回</div>
          <el-button @click="submitForm('ruleForm', 'submit')"
            >保存</el-button
          >
        </div>
        <!-- 表单信息 -->
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          label-position="top"
          class="bus-ruleForm"
        >
          <div class="main-title">企业详情</div>
          <el-form-item label="公司名称（中文）" prop="companyName">
            <el-input
              v-model="ruleForm.companyName"
              placeholder="请填写"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="公司名称（英文）" prop="enCompanyName">
            <el-input
              v-model="ruleForm.enCompanyName"
              placeholder="如无英文名称请填无"
            ></el-input>
          </el-form-item>
          <el-form-item label="所属展会" prop="meeting_type">
            <el-select
              v-model="ruleForm.meeting_type"
              placeholder="请选择"
              disabled
            >
              <el-option
                v-for="item in meetingOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属销售" prop="belong_person">
            <el-input
              v-model="ruleForm.belong_person"
              placeholder="请填写"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="展位类型" prop="booth_type">
            <el-select
              v-model="ruleForm.booth_type"
              placeholder="请选择"
              disabled
            >
              <el-option
                v-for="item in boothOptions"
                :key="item.key"
                :label="item.value"
                :value="item.key"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="展位号" prop="boothNo">
            <el-input
              v-model="ruleForm.boothNo"
              placeholder="请填写"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="展位面积（平米）" prop="boothArea">
            <el-input
              v-model="ruleForm.boothArea"
              placeholder="请填写"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item
            label="业务性质"
            prop="business_nature_idstr"
            class="form-width"
          >
            <el-checkbox-group v-model="ruleForm.business_nature_idstr">
              <el-checkbox
                v-for="item in businessOptions"
                :key="item.key"
                :label="item.key"
                >{{ item.value }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>
          <el-form-item
            label="企业性质"
            prop="companyNature"
            class="form-width"
          >
            <el-checkbox-group v-model="ruleForm.companyNature">
              <el-checkbox
                v-for="item in companyOptions"
                :key="item.key"
                :label="item.value"
              ></el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="企业/品牌Logo" prop="logo" class="form-width">
            <div class="image" v-if="ruleForm.logo">
              <el-image
                v-if="ruleForm.logo.includes('http')"
                :src="ruleForm.logo"
              ></el-image>
              <el-image
                v-else-if="ruleForm.logo.includes('/var/')"
                :src="$imgOssUrl + ruleForm.logo.substring(1)"
              ></el-image>
              <el-image v-else :src="$imgOssUrl + ruleForm.logo"></el-image>
              <div class="upload-span">
                <span
                  v-if="ruleForm.logo.includes('http')"
                  class="upload-icon"
                  @click.stop="handlePictureCardPreview(ruleForm.logo)"
                  ><i class="el-icon-zoom-in"></i
                ></span>
                <span
                  class="upload-icon"
                  v-else-if="ruleForm.logo.includes('/var/')"
                  @click.stop="
                    handlePictureCardPreview(
                      $imgOssUrl + ruleForm.logo.substring(1)
                    )
                  "
                  ><i class="el-icon-zoom-in"></i
                ></span>
                <span
                  v-else
                  class="upload-icon"
                  @click.stop="
                    handlePictureCardPreview($imgOssUrl + ruleForm.logo)
                  "
                  ><i class="el-icon-zoom-in"></i
                ></span>
                <span
                  class="upload-icon"
                  @click.stop="handleRemove()"
                  style="margin-left: 20px"
                  ><i class="el-icon-delete"></i
                ></span>
              </div>
            </div>

            <div v-if="!ruleForm.logo">
              <el-upload
                :action="$Url"
                list-type="picture-card"
                :headers="headers"
                :multiple="false"
                :before-upload="beforeUpload"
                :on-progress="handleProgressLogo"
                :on-success="handleLogoSuccess"
                :on-error="handleLogoError"
                :show-file-list="false"
              >
                <i class="el-icon-plus" v-if="!progressLogoVisible"></i>
                <div v-if="progressLogoVisible" style="padding-top: 30px">
                  <el-progress
                    :percentage="progressLogoPercent"
                    type="circle"
                    :width="80"
                  ></el-progress>
                </div>
              </el-upload>
            </div>
            <div class="img-tips">
              上传图片接受JPG、PNG格式、图片大小不超过2M,分辨率不小于300dpl
            </div>
          </el-form-item>
          <el-form-item
            label="上传企业店铺宣传图"
            prop="imgs"
            class="form-width"
          >
            <div style="display: flex">
              <div class="image-wrap" v-if="ruleForm.imgs">
                <div
                  class="image"
                  v-for="(item, index) in ruleForm.imgs"
                  :key="item.url"
                >
                  <el-image
                    v-if="item.url.includes('http')"
                    :src="item.url"
                  ></el-image>
                  <el-image
                    v-else-if="item.url.includes('/var/')"
                    :src="$imgOssUrl + item.url.substring(1)"
                  ></el-image>
                  <el-image v-else :src="$imgOssUrl + item.url"></el-image>
                  <div class="upload-span">
                    <span
                      class="upload-icon"
                      v-if="item.url.includes('http')"
                      @click.stop="handlePictureCardPreview(item.url)"
                      ><i class="el-icon-zoom-in"></i
                    ></span>
                    <span
                      class="upload-icon"
                      v-else-if="item.url.includes('/var/')"
                      @click.stop="
                        handlePictureCardPreview(
                          $imgOssUrl + item.url.substring(1)
                        )
                      "
                      ><i class="el-icon-zoom-in"></i
                    ></span>
                    <span
                      class="upload-icon"
                      v-else
                      @click.stop="
                        handlePictureCardPreview($imgOssUrl + item.url)
                      "
                      ><i class="el-icon-zoom-in"></i
                    ></span>
                    <span
                      class="upload-icon"
                      @click.stop="handleImgRemove(index)"
                      style="margin-left: 20px"
                      ><i class="el-icon-delete"></i
                    ></span>
                  </div>
                </div>
              </div>

              <div v-if="ruleForm.imgs.length < 3">
                <el-upload
                  :action="$Url"
                  list-type="picture-card"
                  :headers="headers"
                  :multiple="false"
                  :before-upload="beforeUpload"
                  :on-success="handleImgsSuccess"
                  :on-progress="handleProgress"
                  :on-error="handleImgsError"
                  :show-file-list="false"
                >
                  <i class="el-icon-plus" v-if="!progressVisible"></i>
                  <div v-if="progressVisible" style="padding-top: 30px">
                    <el-progress
                      :percentage="progressPercent"
                      type="circle"
                      :width="80"
                    ></el-progress>
                  </div>
                </el-upload>
              </div>
            </div>
            <div class="img-tips">
              上传图片接受JPG、PNG格式、图片大小不超过2M,分辨率不小于300dpl，推荐尺寸345px*150px，最多可上传三个文件
            </div>
          </el-form-item>
          <el-form-item label="国家地区" prop="areaClass">
            <!--  -->
            <el-cascader
              v-model="ruleForm.areaClass"
              :props="{ checkStrictly: true }"
              :options="locationdata"
              clearable
            ></el-cascader>
          </el-form-item>
          <el-form-item label="公司地址（中文）" prop="address">
            <el-input
              v-model="ruleForm.address"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item label="公司地址（英文）" prop="enAddress">
            <el-input
              v-model="ruleForm.enAddress"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item label="邮政编码" prop="postcode">
            <el-input
              v-model="ruleForm.postcode"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item label="座机号码" prop="phone">
            <el-input v-model="ruleForm.phone" placeholder="请填写"></el-input>
          </el-form-item>
          <el-form-item label="传真" prop="fax">
            <el-input v-model="ruleForm.fax" placeholder="请填写"></el-input>
          </el-form-item>
          <el-form-item label="官方网站" prop="officialWebsite">
            <el-input
              v-model="ruleForm.officialWebsite"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item label="人员规模（人）" prop="staff_size">
            <el-input
              v-model="ruleForm.staff_size"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item label="年销售额（万）" prop="annual_sales">
            <el-input
              type="number"
              v-model="ruleForm.annual_sales"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item label="统一社会信用代码" prop="uscc_code">
            <el-input
              v-model="ruleForm.uscc_code"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item label="营业执照有效期" prop="license_validity">
            <el-input
              v-model="ruleForm.license_validity"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item label="上传营业执照" prop="license" class="form-width">
            <div style="display: flex">
              <div class="image-wrap" v-if="ruleForm.license">
                <div
                  class="image"
                  v-for="(item, index) in ruleForm.license"
                  :key="item.url"
                >
                  <el-image
                    v-if="item.url.includes('http')"
                    :src="item.url"
                  ></el-image>
                  <el-image
                    v-else-if="item.url.includes('/var/')"
                    :src="$imgOssUrl + item.url.substring(1)"
                  ></el-image>
                  <el-image v-else :src="$imgOssUrl + item.url"></el-image>
                  <div class="upload-span">
                    <span
                      class="upload-icon"
                      v-if="item.url.includes('http')"
                      @click.stop="handlePictureCardPreview(item.url)"
                      ><i class="el-icon-zoom-in"></i
                    ></span>
                    <span
                      class="upload-icon"
                      v-else-if="item.url.includes('/var/')"
                      @click.stop="
                        handlePictureCardPreview(
                          $imgOssUrl + item.url.substring(1)
                        )
                      "
                      ><i class="el-icon-zoom-in"></i
                    ></span>
                    <span
                      class="upload-icon"
                      v-else
                      @click.stop="
                        handlePictureCardPreview($imgOssUrl + item.url)
                      "
                      ><i class="el-icon-zoom-in"></i
                    ></span>
                    <span
                      class="upload-icon"
                      @click.stop="handleLicenseRemove(index)"
                      style="margin-left: 20px"
                      ><i class="el-icon-delete"></i
                    ></span>
                  </div>
                </div>
              </div>
              <div v-if="ruleForm.license.length < 5">
                <el-upload
                  :action="$Url"
                  list-type="picture-card"
                  :headers="headers"
                  :multiple="false"
                  :on-progress="handleProgressLicense"
                  :on-success="handleLicenseSuccess"
                  :on-error="handleLicenseError"
                  :show-file-list="false"
                >
                  <i class="el-icon-plus" v-if="!progressLicensVisible"></i>
                  <div v-if="progressLicensVisible" style="padding-top: 30px">
                    <el-progress
                      :percentage="progressLicensPercent"
                      type="circle"
                      :width="80"
                    ></el-progress>
                  </div>
                </el-upload>
              </div>
            </div>
            <div class="img-tips">
              仅限JPG、PNG格式，大小不超2M，最多可上传5个文件
            </div>
          </el-form-item>
          <el-form-item
            label="公司介绍（中文）"
            prop="introduction"
            class="form-width"
          >
            <el-input
              v-model="ruleForm.introduction"
              type="textarea"
              :rows="5"
              maxlength="150"
              show-word-limit
              resize="none"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="公司介绍（英文）"
            prop="synopsis"
            class="form-width"
          >
            <el-input
              v-model="ruleForm.synopsis"
              type="textarea"
              :rows="5"
              maxlength="500"
              show-word-limit
              resize="none"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人（中文）" prop="contacts">
            <el-input
              v-model="ruleForm.contacts"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人电话" prop="telephoneNumber">
            <el-input
              v-model.number="ruleForm.telephoneNumber"
              :maxlength="11"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item label="电子邮箱" prop="email">
            <el-input v-model="ruleForm.email" placeholder="请填写"></el-input>
          </el-form-item>
          <el-form-item label="联系人微信" prop="wechat">
            <el-input v-model="ruleForm.wechat" placeholder="请填写"></el-input>
          </el-form-item>
          <el-form-item label="QQ号" prop="QQ">
            <el-input v-model="ruleForm.QQ" placeholder="请填写"></el-input>
          </el-form-item>
          <el-form-item label="联系人部门" prop="department">
            <el-input
              v-model="ruleForm.department"
              placeholder="请填写"
            ></el-input>
          </el-form-item>
          <el-form-item label="联系人职务" prop="duties">
            <el-input v-model="ruleForm.duties" placeholder="请填写"></el-input>
          </el-form-item>
          <div class="bus-btn">
            <el-button @click="submitForm('ruleForm', 'submit')"
              >保存</el-button
            >
          </div>
        </el-form>
        <el-dialog :visible.sync="dialogVisible">
          <img width="100%" :src="dialogImageUrl" alt="" />
        </el-dialog>
      </div>
    </div>
  </div>
</template>

<script>
import { getCheckBox, companyDetails, editCompany } from "@/api/api";
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
export default {
  components: { top, navMenu },
  name: "busInformation",
  data() {
    // 手机号码验证规则
    var validatePhone = (rule, value, callback) => {
      const reg = /^1[3-9]\d{9}$/;
      if (value === "") {
        callback(new Error("手机号码不能为空"));
      } else if (!reg.test(value)) {
        callback(new Error("请输入正确的手机号码"));
      } else {
        callback();
      }
    };
    return {
      active: 0,
      loading: false,
      ruleForm: {
        companyName: "",
        enCompanyName: "",
        meeting_type: "",
        belong_person: "",
        booth_type: "",
        boothNo: "",
        boothArea: "",
        business_nature_idstr: [],
        companyNature: [],
        logo: "",
        imgs: [],
        areaClass: [],
        address: "",
        enAddress: "",
        postcode: "",
        phone: "",
        fax: "",
        officialWebsite: "",
        staff_size: "",
        annual_sales: "",
        uscc_code: "",
        license_validity: "",
        license: [],
        introduction: "",
        synopsis: "",
        contacts: "",
        telephoneNumber: "",
        email: "",
        wechat: "",
        QQ: "",
        department: "",
        duties: "",
      },
      rules: {
        companyName: [{ required: true, message: "请填写", trigger: "blur" }],
        enCompanyName: [{ required: true, message: "请填写", trigger: "blur" }],
        uscc_code: [{ required: true, message: "请填写", trigger: "blur" }],
        license_validity: [
          { required: true, message: "请填写", trigger: "blur" },
        ],
        contacts: [{ required: true, message: "请填写", trigger: "blur" }],
        telephoneNumber: [
          {
            required: true,
            validator: validatePhone,
            trigger: "blur",
          },
        ],
        introduction: [{ required: true, message: "请填写", trigger: "blur" }],
        business_nature_idstr: [
          { required: true, message: "请填写", trigger: "blur" },
        ],
        companyNature: [{ required: true, message: "请填写", trigger: "blur" }],
        license: [{ required: true, message: "请上传", trigger: "blur" }],
      },
      locationdata: [],
      headers: {},
      dialogVisible: false,
      dialogImageUrl: "",
      meetingOptions: [],
      businessOptions: [],
      companyOptions: [],
      boothOptions: [],
      progressVisible: false,
      progressPercent: 0,
      progressLogoVisible: false,
      progressLogoPercent: 0,
      progressLicensVisible: false,
      progressLicensPercent: 0,
    };
  },
  mounted() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "conference";
    });
    this.active = index;
    this.locationdata = JSON.parse(localStorage.getItem("locationdata"));
    let token = localStorage.getItem("token");
    this.headers = {
      token: token,
    };
    this.mark = this.$route.query.mark;
    this.getCheckBoxData();
    this.getInfor();
  },

  methods: {
    // 返回
    goBack() {
      this.$router.back();
    },
    //获取选项
    getCheckBoxData() {
      getCheckBox("975,798,964,778")
        .then((res) => {
          if (res.data.code == 1) {
            let data = res.data.data;
            // 所属企业选项
            this.meetingOptions = data[798];
            // 展位类型选项
            this.boothOptions = data[778];
            // 业务性质选项
            this.businessOptions = data[975];
            // 企业性质选项
            this.companyOptions = data[964];
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //获取展商信息
    getInfor() {
      this.loading = true;
      companyDetails()
        .then((res) => {
          //console.log(res, "=<======res");
          if (res.data.code == 1) {
            let { data } = res.data;
            let {
              id,
              companyName,
              enCompanyName,
              meeting_type,
              belong_person,
              booth_type,
              boothNo,
              boothArea,
              business_nature_idstr,
              companyNature,
              logo,
              imgs,
              areaClass1,
              areaClass2,
              address,
              enAddress,
              postcode,
              phone,
              fax,
              officialWebsite,
              staff_size,
              annual_sales,
              uscc_code,
              license_validity,
              license,
              introduction,
              synopsis,
              contacts,
              telephoneNumber,
              email,
              wechat,
              QQ,
              department,
              duties,
            } = data;
            let infor = {
              id,
              companyName,
              enCompanyName,
              meeting_type,
              belong_person,
              booth_type,
              boothNo,
              boothArea,
              logo,
              imgs,
              address,
              enAddress,
              postcode,
              phone,
              fax,
              officialWebsite,
              staff_size,
              annual_sales,
              uscc_code,
              license_validity,
              license,
              introduction,
              synopsis,
              contacts,
              telephoneNumber,
              email,
              wechat,
              QQ,
              department,
              duties,
              areaClass: [],
            };
            infor.business_nature_idstr = business_nature_idstr.split(",");
            infor.companyNature = companyNature.split(",");
            infor.areaClass[0] = Number(areaClass1);
            if (areaClass2 != 0) {
              infor.areaClass[1] = Number(areaClass2);
            }
            this.ruleForm = infor;
            console.log(this.ruleForm, "=====f=afadf");
            if (
              this.ruleForm.imgs == null ||
              this.ruleForm.imgs == "" ||
              this.ruleForm.imgs == undefined
            ) {
              this.ruleForm.imgs = [];
            }
            if (
              this.ruleForm.license == null ||
              this.ruleForm.license == "" ||
              this.ruleForm.license == undefined
            ) {
              this.ruleForm.license = [];
            }
            this.loading = false;
          }
        })
        .catch((err) => {});
    },
    // 保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let data = this.ruleForm;
          // data.areaClass = data.areaClass.join(",");
          data.companyNature = data.companyNature.join(",");
          data.business_nature_idstr = data.business_nature_idstr.join(",");
          let imgs = [];
          if (data.imgs.length > 0) {
            data.imgs.forEach((item) => {
              imgs.push(item.url);
            });
            imgs = imgs.join(",");
          } else {
            imgs = "";
          }

          let arr = [];
          if (data.license.length > 0) {
            data.license.forEach((item) => {
              arr.push(item.url);
            });
            arr = arr.join(",");
          } else {
            arr = "";
          }

          let dataNew = {
            enCompanyName: data.enCompanyName,
            business_nature_idstr: data.business_nature_idstr,
            companyNature: data.companyNature,
            logo: data.logo,
            imgs: imgs,
            areaClass1: data.areaClass.length > 0 ? data.areaClass[0] : "",
            areaClass2: data.areaClass.length > 1 ? data.areaClass[1] : "",
            address: data.address,
            enAddress: data.enAddress,
            postcode: data.postcode,
            phone: data.phone,
            fax: data.fax,
            officialWebsite: data.officialWebsite,
            staff_size: data.staff_size,
            annual_sales: data.annual_sales,
            uscc_code: data.uscc_code,
            license_validity: data.license_validity,
            license: arr,
            introduction: data.introduction,
            synopsis: data.synopsis,
            contacts: data.contacts,
            telephoneNumber: data.telephoneNumber,
            email: data.email,
            wechat: data.wechat,
            QQ: data.QQ,
            department: data.department,
            duties: data.duties,
            mark: this.mark,
          };
          this.editCompany(dataNew);
        } else {
          let that = this;
          that.$nextTick(() => {
            //加个定时器，有可能监测不到页面变化
            let timer = setTimeout(function () {
              that.scrollToFormError();
              clearTimeout(timer);
            }, 200);
          });
        }
      });
    },
    //企业信息保存
    editCompany(data) {
      this.loading = true;
      editCompany(data)
        .then((res) => {
          this.loading = false;
          if (res.data.code == 1) {
            this.$message.success(res.data.msg);
            //返回上一页
            setTimeout(() => {
              this.goBack();
            }, 1000);
          } else {
            this.$message.warning(res.data.message);
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    //滑动到错误对应位置
    scrollToFormError() {
      // 获取第一个校验错误的元素
      const element = document.querySelectorAll(".el-form-item__error")[0];
      // 滚动到错误元素对应位置
      element.scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
    },
    handleRemove(file, fileList) {
      this.$alert("确定要删除吗!", "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.ruleForm.logo = "";
          }
        },
      });
    },
    //限制用户上传的图片大小
    beforeUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 7;
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 7MB!");
      }
      return isLt2M;
    },
    //logo上传进度
    handleProgressLogo(event, file, fileList) {
      // 显示进度条
      this.progressLogoVisible = true;
      // 计算进度百分比
      this.progressLogoPercent = Math.floor((event.loaded / event.total) * 100);
    },
    // logo上传成功
    handleLogoSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      this.ruleForm.logo = resData.data.url;
      this.progressLogoVisible = false;
    },
    // logo上传失败
    handleLogoError(err, file, fileList) {
      this.$message.error(err.message);
      this.progressLogoVisible = false;
    },
    //上传进度
    handleProgress(event, file, fileList) {
      // 显示进度条
      this.progressVisible = true;
      // 计算进度百分比
      this.progressPercent = Math.floor((event.loaded / event.total) * 100);
    },
    //企业店铺宣传图上传成功
    handleImgsSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      if (this.ruleForm.imgs.length == 0) {
        this.ruleForm.imgs = [];
      }
      this.ruleForm.imgs.push({ url: resData.data.url });
      this.progressVisible = false;
    },
    // 企业店铺宣传图上传失败
    handleImgsError(err, file, fileList) {
      this.progressVisible = false;
      this.$message.error(err.message);
    },
    //企业店铺宣传删除
    handleImgRemove(index) {
      this.$alert("确定要删除吗!", "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.ruleForm.imgs.splice(index, 1);
          }
        },
      });
    },
    handleProgressLicense(event, file, fileList) {
      // 显示进度条
      this.progressLicensVisible = true;
      // 计算进度百分比
      this.progressLicensPercent = Math.floor(
        (event.loaded / event.total) * 100
      );
    },
    //营业执照上传成功
    handleLicenseSuccess(resData, file, fileList) {
      if (resData.code == 0) {
        this.$message.error(resData.msg);
        return false;
      }
      if (this.ruleForm.license.length == 0) {
        this.ruleForm.license = [];
      }
      this.ruleForm.license.push({ url: resData.data.url });
      this.progressLicensVisible = false;
    },
    // 营业执照上传失败
    handleLicenseError(err, file, fileList) {
      this.progressLicensVisible = false;
      this.$message.error(err.message);
    },
    //营业执照删除
    handleLicenseRemove(index) {
      this.$alert("确定要删除吗!", "", {
        confirmButtonText: "确定",
        callback: (action) => {
          if (action == "confirm") {
            this.ruleForm.license.splice(index, 1);
          }
        },
      });
    },
    //预览图片
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file;
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.content .el-button {
  color: #fff;
  position: absolute;
  bottom: 30px;
  left: 50%;
  background: #008dff;
}
.go-back {
  margin-bottom: 20px;
}
.content {
  padding-bottom: 40px;
  .bus-ruleForm {
    display: flex;
    flex-wrap: wrap;
    margin-top: 85px;
    margin-bottom: 100px;
    width: 100%;
    background: #fff;
    padding: 30px 40px 40px;
    box-sizing: border-box;
    border-radius: 10px;
    .el-form-item {
      width: 37%;
      margin-right: 60px;
      .el-select,
      .el-cascader {
        width: 100%;
      }
      .el-input__inner {
        height: 50px;
        line-height: 50px;
      }
      .el-tag {
        min-width: 100px;
        height: 38px;
        color: #48484a;
        margin-right: 8px;
        margin-bottom: 8px;
        font-size: 12px;
        line-height: 38px;
        text-align: center;
        background: #fff;
        border-radius: 6px;
        cursor: pointer;
        border: 1px solid #e0e0e0;
      }
      .select {
        color: #1677ff;
        border-color: #1677ff;
      }
      .el-textarea__inner {
        border-radius: 9px;
      }
    }

    .form-width {
      width: 80%;
    }
    .form-label {
      .el-tag + .el-tag {
        margin-left: 10px;
        margin-bottom: 10px;
      }
      .button-new-tag,
      .input-new-tag {
        width: 200px;
        height: 50px;
        color: #48484a;
        display: inline-block;
        margin-right: 8px;
        font-size: 18px;
        line-height: 50px;
        text-align: center;
        background: #fff;
        border-radius: 9px;
        border: 1px solid #e0e0e0;
      }
      .input-new-tag {
        border: 0 none;
      }
    }
    .product-class {
      align-items: center;
      .el-select {
        width: 200px;
        margin-right: 12px;
      }
      .el-button {
        min-width: auto;
        width: 23px;
        height: 23px;
        font-size: 12px;
        text-align: center;
        line-height: 23px;
        padding: 0;
        position: inherit;
        transform: none;
        border-radius: 50%;
      }
      .el-button + .el-button {
        margin-left: 20px;
      }
      .el-button--danger {
        color: #fff !important;
        background-color: #f56c6c !important;
        border-color: #f56c6c !important;
      }
      .el-button--primary {
        color: #fff !important;
        background-color: #409eff !important;
        border-color: #409eff !important;
      }
    }
  }
}
.img-tips {
  color: red;
  font-size: 12px;
}
.image-wrap {
  display: flex;
  .image {
    margin-right: 10px;
  }
}
.image {
  width: 148px;
  height: 148px;
  border-radius: 6px;
  position: relative;
  /deep/ .el-image {
    width: 148px;
    height: 148px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 6px;
    .el-image__inner {
      width: auto;
      height: auto;
      max-width: 100%;
      max-height: 100%;
    }
  }
  .upload-span {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.4);
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0;
    transition: all 0.1s;
    border-radius: 6px;
    .upload-icon {
      color: #fff;
      font-size: 22px;
    }
  }
  &:hover {
    .upload-span {
      opacity: 1;
    }
  }
}
.content-top {
  display: flex;
  position: fixed;
  top: 100px;
  left: 260px;
  z-index: 99;
  width: 100%;
  padding: 30px 0 20px;
  background: #f1f5f8;
  .el-button {
    position: relative;
    left: 0;
    bottom: 0;
    height: 44px;
    line-height: 44px;
    margin-left: 20px;
    transform: translateX(0);
  }
}
@media only screen and (max-width: 767px) {
  .content {
    margin: 0;
    padding: 20px;
    .main-title {
      margin: 10px 0;
    }
    .bus-ruleForm {
      padding: 20px;
      .el-form-item {
        width: 100%;
        margin-right: 0;
        margin-bottom: 10px;
        /deep/ .el-form-item__label {
          line-height: 30px;
        }
      }
    }
  }
}
</style>